import styled from 'styled-components';
import { GREY_200, GREY_500, GREY_800 } from '../../../../constants';

export const Container = styled.div`
    padding: 0.75rem 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    gap: 1rem;
    height: 100%;
`;

export const FieldsContainer = styled.div`
    display: flex;
    justify-items: stretch;
    align-content: center;
    gap: 1rem;
    padding: 1.5rem 0 1rem;


    & > div {
        flex: 1;
    }
`;

export const Message = styled.div`
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.375rem;
    color: ${GREY_200};
    text-align: center;
    padding-top: 0.75rem;
`;

export const TableContainer = styled.div`
    padding: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: auto;
    height: 100%;
`;

export const Title = styled.h3`
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.0125rem;
    color: ${GREY_800};
`;

export const Description = styled.p`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1rem;
    color: ${GREY_500};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 100%;
    padding: 0 1.5rem;
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 0.50rem;
`;
